import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as stAPI from '../../lib/api/stapi';
import { takeLatest } from 'redux-saga/effects';

// [START] API 서버에 Request ------------------------->

const [
    ST_CONTENTS,
    ST_CONTENTS_SUCCESS,
    ST_CONTENTS_FAILURE,
] = createRequestActionTypes('sp/ST_CONTENTS');

const [
    ST_ITEM,
    ST_ITEM_SUCCESS,
    ST_ITEM_FAILURE,
] = createRequestActionTypes('sp/ST_ITEM');

const [
    ST_CONTENTS_ADD,
    ST_CONTENTS_ADD_SUCCESS,
    ST_CONTENTS_ADD_FAILURE,
] = createRequestActionTypes('sp/ST_CONTENTS_ADD');

const [
    ST_CONTENTS2,
    ST_CONTENTS2_SUCCESS,
    ST_CONTENTS2_FAILURE,
] = createRequestActionTypes('sp/ST_CONTENTS2');

const [
    ST_CONTENTS2_ADD,
    ST_CONTENTS2_ADD_SUCCESS,
    ST_CONTENTS2_ADD_FAILURE,
] = createRequestActionTypes('sp/ST_CONTENTS2_ADD');

const [
    ST_CONTENTS_DETAIL,
    ST_CONTENTS_DETAIL_SUCCESS,
    ST_CONTENTS_DETAIL_FAILURE,
] = createRequestActionTypes('sp/ST_CONTENTS_DETAIL');

const ST_DEL_FILTER = createRequestActionTypes('sp/ST_DEL_FILTER');
const ST_ITEM_LOC = createRequestActionTypes('sp/ST_ITEM_LOC');
const ST_PRICE_MIN = createRequestActionTypes('sp/ST_PRICE_MIN');
const ST_PRICE_MAX = createRequestActionTypes('sp/ST_PRICE_MAX');
const ST_CUR_PRICE = 'sp/ST_CUR_PRICE'
const ST_CUR_MINMAX_PRICE = 'sp/ST_CUR_MINMAX_PRICE'
const ST_PRICE_FILTER_CHANGE = 'sp/ST_PRICE_FILTER_CHANGE'
const ST_FILTER_CHANGE = 'sp/ST_FILTER_CHANGE'

export const reqStContentsAction = createAction(ST_CONTENTS);
export const reqStContentsAddAction = createAction(ST_CONTENTS_ADD);
export const reqStItemAction = createAction(ST_ITEM);
export const setStDelFilterAction = createAction(ST_DEL_FILTER);
export const setStLocAction = createAction(ST_ITEM_LOC);
export const setStMinPriceAction = createAction(ST_PRICE_MIN);
export const setStMaxPriceAction = createAction(ST_PRICE_MAX)
;
export const reqStContentsDetailAction = createAction(ST_CONTENTS_DETAIL);
export const reqStContents2Action = createAction(ST_CONTENTS2);
export const reqStContents2AddAction = createAction(ST_CONTENTS2_ADD);
export const setStCurPriceAction = createAction(ST_CUR_PRICE);
export const setStCurMINMAXPriceAction = createAction(ST_CUR_MINMAX_PRICE);
export const setStPriceFilterChangeAction = createAction(ST_PRICE_FILTER_CHANGE);
export const setStFilterChangeAction = createAction(ST_FILTER_CHANGE);
/**
 * SAGA API 에서 REST API 호출 
 */
const listStListSaga = createRequestSaga(ST_CONTENTS, stAPI.getList);
const listStListAddSaga = createRequestSaga(ST_CONTENTS_ADD, stAPI.getList);
const listStItemSaga = createRequestSaga(ST_ITEM, stAPI.getItem);
const listStListSaga2 = createRequestSaga(ST_CONTENTS2, stAPI.getList2);
const listStListAddSaga2 = createRequestSaga(ST_CONTENTS2_ADD, stAPI.getList2);
const listStListDetailSaga = createRequestSaga(ST_CONTENTS_DETAIL, stAPI.getList);

export function* stContentsSaga() {
    yield takeLatest(ST_CONTENTS, listStListSaga);
    yield takeLatest(ST_ITEM, listStItemSaga);
    yield takeLatest(ST_CONTENTS_ADD, listStListAddSaga);
    yield takeLatest(ST_CONTENTS2, listStListSaga2);
    yield takeLatest(ST_CONTENTS2_ADD, listStListAddSaga2);
    yield takeLatest(ST_CONTENTS_DETAIL, listStListDetailSaga);
}
// [END] API 서버에 Request ------------------------------>

/**
 * Store에 저장될 값 
 */
const initialState = {
    stItems: null,
    stDetail: null,
    error: null,
    stDelFilterInfo: null,
    minPrice: 0,
    maxPrice: 9000000,
    priceFilterChange: false,    //가격 필터 변동 여부 체크
    curPrice: [0, 0],             //가격 필터 현재 가격
    curMinMaxPrice: [0, 0],       //가격 필터 최대/최소 가격
    filterChange: false,    //필터 변동 여부 체크
    stItemsDetail: null,
    locinfo: null
}

const stContentsReducer = handleActions(
    {
        [ST_CONTENTS_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                stItems: payload,
                error: null,
            })
        },
        [ST_CONTENTS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            stDelFilterInfo: [],
            stItems: null,
            error,
        }),
        [ST_CONTENTS_ADD_SUCCESS]: (state, { payload }) => {
            let dataList = state.stItems.concat(payload);

           /*  let data = Object.assign({}, state.stItems);
            data.dataList = [];
            Object.assign(data.dataList, dataList); */

            return ({
                ...state,
                stItems: dataList,
                error: null,
            })
        },
        [ST_CONTENTS_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ST_DEL_FILTER]: (state, { payload: stDelFilterInfo }) => ({
            ...state,
            stDelFilterInfo: stDelFilterInfo
        }),
        [ST_ITEM_LOC]: (state, { payload: locinfo }) => ({
            ...state,
            locinfo: locinfo
        }),
        [ST_ITEM_SUCCESS]: (state, { payload }) => {

            // console.log("payload : " + JSON.stringify(payload));

            return ({
                ...state,
                stDetail: payload,
                //stDelFilterInfo: [],
                error: null,
            })
        },
        [ST_ITEM_FAILURE]: (state, { payload: error }) => ({
            ...state,
            stDelFilterInfo: [],
            stItems: null,
            stDetail: null,
            error,
        }),
        [ST_PRICE_MIN]: (state, { payload: minPrice }) => ({
            ...state,
            minPrice: minPrice
        }),
        [ST_PRICE_MAX]: (state, { payload: maxPrice }) => ({
            ...state,
            maxPrice: maxPrice
        }),
        [ST_CONTENTS2_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                stItems: payload,
                error: null,
            })
        },
        [ST_CONTENTS2_FAILURE]: (state, { payload: error }) => ({
            ...state,
            stDelFilterInfo: [],
            stItems: null,
            error,
        }),
        [ST_CONTENTS2_ADD_SUCCESS]: (state, { payload }) => {
            let dataList = state.stItems.concat(payload);

           /*  let data = Object.assign({}, state.stItems);
            data.dataList = [];
            Object.assign(data.dataList, dataList); */

            return ({
                ...state,
                stItems: dataList,
                error: null,
            })
        },
        [ST_CONTENTS2_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ST_CUR_PRICE]: (state, { payload: curPrice }) => {
            return ({
                ...state,
                curPrice: curPrice,
            })
        },
        [ST_CUR_MINMAX_PRICE]: (state, { payload: curMinMaxPrice }) => {
            return ({
                ...state,
                curMinMaxPrice: curMinMaxPrice,
            })
        },
        [ST_PRICE_FILTER_CHANGE]: (state, { payload: priceFilterChange }) => {
            return ({
                ...state,
                priceFilterChange: priceFilterChange,
            })
        },
        [ST_FILTER_CHANGE]: (state, { payload: filterChange }) => {
            return ({
                ...state,
                filterChange: filterChange,
            })
        },
        [ST_CONTENTS_DETAIL_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                stItemsDetail: payload,
                error: null,
            })
        },
        [ST_CONTENTS_DETAIL_FAILURE]: (state, { payload: error }) => ({
            ...state,
            stItemsDetail: null,
            error,
        }),
    }
    , initialState);

export default stContentsReducer;
